import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  inject,
  OnInit,
  viewChild
} from '@angular/core';
import { BaseComponent } from '@app/components/base/base.component';
import { ImageComponent } from '@app/components/image/image.component';
import { SpinnerComponent } from '@app/components/spinner/spinner.component';
import { GetImagePathPipe } from '@app/pipes/get-image-path/get-image-path.pipe';
import { AppsStarterService } from '@app/services/apps-starter/apps-starter.service';

@Component({
  imports: [CommonModule, GetImagePathPipe, SpinnerComponent, ImageComponent],
  selector: 'app-apps-starter',
  templateUrl: './apps-starter.component.html',
  styleUrls: ['./apps-starter.component.scss']
})
export class AppsStarterComponent extends BaseComponent implements OnInit {
  private readonly appsStarterService: AppsStarterService = inject(AppsStarterService);
  public dialog = viewChild.required<ElementRef>('dialog');

  public ngOnInit(): void {
    this.data = this.appsStarterService.getItems();
  }

  public openDialog(): void {
    this.dialog().nativeElement.showModal();
  }

  public closeDialog($event?: MouseEvent): void {
    $event?.preventDefault();
    this.dialog().nativeElement.close();
  }
}
